var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-chart',{ref:"chart",staticClass:"w-100 h-100",attrs:{"options":_vm.generateOption,"not-merge":"","group-id":_vm.groupId}})
}
var staticRenderFns = []

export { render, staticRenderFns }